import { Stack, Tabs } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Content from "src/components/Content";
import { useAuthContext } from "src/auth/AuthContext";
import { useParams } from "react-router-dom";
import { User } from "@/api/User";
import { userService } from "@/service/UserService";
import TimesheetCalendar from "./components/TimesheetCalendar";
import YearlyReport from "./components/YearlyReport";
import { Alert } from '@/components/ui/alert';
import { useI18n } from '@/i18n/I18nContext';



const OverviewTimesheet = () => {
  const { t } = useI18n();
  const { user } = useAuthContext();
  const { id } = useParams();
  const userId = id ? parseInt(id) : user?.data?.id;

  const [member, setMember] = useState<User | null>(null);
  const [activeTab, setActiveTab] = useState("monthlyCalendar");
  const behalfOf: Boolean = (id && member && userId !== user?.data?.id) || false;

  useEffect(() => {
    if (userId) {
      userService.find(userId).then(r => setMember(r));
      // TODO: extract project names here and distribute to calendar and yearly report
    }
  }, [userId]);

  return (
    <Content title={t('workspaces.timesheet.title')} description={t('workspaces.timesheet.description')}>
      <Stack gap='6' minW='0'>
        {behalfOf && (
          <Alert status='warning' title={t('workspaces.timesheet.onBehalf', { name: member?.firstName ?? '' })}>
            {t('workspaces.timesheet.onBehalfDescription')}
          </Alert>
        )}
        <Tabs.Root value={activeTab} onValueChange={({ value }) => setActiveTab(value)} lazyMount>
          <Tabs.List>
            <Tabs.Trigger value='monthlyCalendar'>
              {t('workspaces.timesheet.monthly')}
            </Tabs.Trigger>
            <Tabs.Trigger value='yearlyReport'>
              {t('workspaces.timesheet.yearly')}
            </Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value='monthlyCalendar' px='0' pt='6' pb='0' minW='0'>
            <TimesheetCalendar userId={userId} organizationId={user?.data?.organizationId} active={activeTab === 'monthlyCalendar'} />
          </Tabs.Content>
          <Tabs.Content value='yearlyReport' px='0' pt='6' pb='0' minW='0'>
            <YearlyReport userId={userId} organizationId={user?.data?.organizationId} active={activeTab === 'yearlyReport'} />
          </Tabs.Content>
        </Tabs.Root>
      </Stack>
    </Content>
  );
}
export default OverviewTimesheet;
